import React, { useState } from "react";
import StoreIdSelect from "../common/StoreIdSelect";
import { saveAcquirerStore } from "../../service/AcquirerStoreRequest";

import {TextField,
    Button, Box, Container, makeStyles,Paper,Grid,FormControl,
    Select,
    MenuItem,
    InputLabel,
} from '@material-ui/core';
import {
    AcquirerStoreFormBottonControl,
} from './style/AcquirerStoreStyle';

import { styled } from '@mui/material/styles';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'left',
    color: theme.palette.text.secondary,
    margin:10,
  }));

const userStyles = makeStyles({
    field: {
        marginTop: 20,
        marginBottom: 10,
        width:'100%'

    },
    selectType:{
        marginTop: 10,
        width:'100%',
        textAlign:'center',
        
      }
});
export default function AcquirerStoreForm({
    handleAddClose,
    handleSubmit,
    }) {
    const classes = userStyles();

    const [storeCurrency, setStoreCurrency] = useState();
    const [parameterJson, setParameterJson] = useState();
    const [chargeRateId, setChargeRateId] = useState();
    const [settlementConfig, setSettlementConfig] = useState();
    const [storeId, setStoreId] = useState();
    const [acquirerType, setAcquirerType] = useState();
    const [parameterOne, setParameterOne] = useState();
    const [parameterTwo, setParameterTwo] = useState();
    const [parameterThree, setParameterThree] = useState();
    const [parameterFour, setParameterFour] = useState();
    const [activeStatus, setActiveStatus] = useState();
    const [settlementType, setSettlementType] = useState();
    const [acquirerMode,setAcquirerMode]=useState();
    const [chargeRate, setChargeRate] = useState();
    const [cardType, setCardType] = useState();
    const [cardBelong, setCardBelong] = useState();
    const [acquirerTypeOpen,setAcquirerTypeOpen]=useState(false);
    const [cardTypeOpen,setCardTypeOpen]=useState(false);

    const [cardBelongOpen,setCardBelongOpen]=useState(false);
    const handleSubmitData=async (e) =>{
        e.preventDefault();
        


        const saveAcquirerStoreDto = {
            "storeId":storeId,
            'acquirerType': acquirerType,
            'storeCurrency': storeCurrency,
            'parameterOne': parameterOne,
            'parameterTwo': parameterTwo,
            "parameterThree":parameterThree,
            "parameterFour":parameterFour,
            'settlementMethod': settlementType,
             
            'acquirerMode': acquirerMode,
            'chargeRate': chargeRate,
            "cardType":cardType,
            "cardBelong":cardBelong,
            
        };
        await saveAcquirerStore(saveAcquirerStoreDto);

    

        handleSubmit();
    };

    const setStoreIdChange = (storeText) => {
        console.log("setStoreIdChange===", storeText);
        if (storeText) {
          setStoreId(storeText.id);
        }
      };

      const handleAcquirerTypeClose =()=>{
        setAcquirerTypeOpen(false);
      } 
    
      const handleAcquirerTypeOpen =()=>{
        setAcquirerTypeOpen(true);
      }
    
      const handleAcquirerTypeChange= (event)=>{
        setAcquirerType(event.target.value);
      }

      const handleCardTypeClose =()=>{
        setCardTypeOpen(false);
      } 

      const handleCardTypeOpen =()=>{
        setCardTypeOpen(true);
      }
      const handleCardTypeChange= (event)=>{
        setCardType(event.target.value);
      }

      const handleCardBelongClose =()=>{
        setCardBelongOpen(false);
      } 

      const handleCardBelongOpen =()=>{
        setCardBelongOpen(true);
      }
      const handleCardBelongChange= (event)=>{
        setCardBelong(event.target.value);
      }
    
    return (
         


            <Container >


                <form noValidate autoComplete="off" onSubmit={handleSubmitData}>


                <Grid container spacing={2}>
                    <Grid item xs={4}>
                    <Item elevation={0}  > 
                    <StoreIdSelect setStoreIdChange={setStoreIdChange} />
                    </Item>
                    </Grid>
                    <Grid item xs={4}>
                         <Paper className={classes.selectType}>
                                                
                        
                                                     <FormControl className={classes.selectType}>
                                                              <InputLabel id="acquirerType">AcquirerType</InputLabel>
                                                              <Select 
                                                              labelId="acquirerType"
                                                              id="acquirerType-select"
                                                              open={acquirerTypeOpen}
                                                              onClose={handleAcquirerTypeClose}
                                                              onOpen={handleAcquirerTypeOpen}
                                                              value={acquirerType}
                                                              onChange={handleAcquirerTypeChange}
                                                              >
                                                              <MenuItem value="">
                                                                  <em>None</em>
                                                              </MenuItem>  
                                                              <MenuItem value="GRAB_MERCHANT_PRESENTED_QR_GRAB_PAY">Grab</MenuItem>
                                                              <MenuItem value="GRAB_MERCHANT_PRESENTED_QR_PAY_LATER">GrabLater</MenuItem>
                                                              <MenuItem value="ALI_MERCHANT_SCAN_USER_QR_PAY">Alipay</MenuItem>
                                                              <MenuItem value="ALI_STATIC_QR_CODE">AlipayStatic</MenuItem>
                                                              
                                                              <MenuItem value="WECHAT_MERCHANT_SCAN_USER_QR_PAY">Wechat</MenuItem>
                                                              <MenuItem value="MINI_PROGRAM_WECHAT_MERCHANT_PAY">WechatMiniProgram</MenuItem>
                        
                                                              <MenuItem value="WECHAT_IN_APP_MERCHANT_PAY">WechatInApp</MenuItem>
                                                              <MenuItem value="WECHAT_NATIVE_MERCHANT_PAY">WechatNative</MenuItem>
                        
                                                              <MenuItem value="WECHAT_H5_MERCHANT_PAY">WechatH5</MenuItem>
                                                              <MenuItem value="WECHAT_JSAPI_MERCHANT_PAY">WechatJsapi</MenuItem>
                        
                        
                                                              <MenuItem value="DBS_PAY_NOW_MERCHANT_PRESENTED_QR_PAY">DbsPayNow</MenuItem>
                        
                                                              <MenuItem value="CHECK_OUT_PAY">Checkout</MenuItem>
                                                              <MenuItem value="DCS_CARD_NOW_PAY">DCSCardNow</MenuItem>
                                                              <MenuItem value="SOLANA_PAY">solanaPay</MenuItem>
                                                              </Select>
                                                          </FormControl>
                                                </Paper>
          
                    </Grid>
                        <Grid item xs={4}>
                        <TextField
                                    onChange={((e)=> setStoreCurrency(e.target.value))}
                                    className={classes.field}
                                    id="standard-disabled"
                                    label="Store Currency"
                                    variant="standard"
                                    placeholder="SGD"
                                    required
                                />
                        </Grid>
                 </Grid>
                 <Grid container spacing={2}>
                    <Grid item xs={4}>
                        <Item elevation={0} > 
                        <TextField id="parameterOne" className={classes.field} label="ParameterOne" variant="standard" onChange={((e)=> setParameterOne(e.target.value))}/>
                        </Item>
                    </Grid>

                    <Grid item xs={4}>
                        <Item elevation={0} > 
                        <TextField id="parameterTwo" className={classes.field} label="ParameterTwo" variant="standard" onChange={((e)=> setParameterTwo(e.target.value))}/>
                        </Item>
                    </Grid>

                    <Grid item xs={4}>
                        <Item elevation={0} > 
                        <TextField id="parameterThree" className={classes.field} label="ParameterThree" variant="standard" onChange={((e)=> setParameterThree(e.target.value))}/>
                        </Item>
                    </Grid>
                 </Grid>

                 <Grid container spacing={2}>
                    <Grid item xs={4}>
                        <Item elevation={0}> 
                        <TextField id="parameterFour" className={classes.field} label="ParameterFour" variant="standard" onChange={((e)=> setParameterFour(e.target.value))}/>
                        </Item>
                    </Grid> 
                    <Grid item xs={4}>
                        <Item elevation={0}> 
                        <TextField id="settlementType" className={classes.field} label="Settlement Type" variant="standard" onChange={((e)=> setSettlementType(e.target.value))} required/>
                        </Item>
                    </Grid> 
                    <Grid item xs={4}>
                        <Item elevation={0}> 
                        <TextField id="acquirerMode" className={classes.field} label="Acquirer Mode" variant="standard" onChange={((e)=> setAcquirerMode(e.target.value))} required/>
                        </Item>
                    </Grid> 
                 </Grid>
                 <Grid container spacing={2}>
                    <Grid item xs={4}>
                        <Item elevation={0}>
                        <TextField id="chargeRate" className={classes.field} label="Charge Rate " onChange={((e)=> setChargeRate(e.target.value))} variant="standard"  required/>
                        </Item>
                    </Grid>
                    <Grid item xs={4}>
                        <Item elevation={0}>

                        <Paper className={classes.selectType}>
                                                
                        
                                                <FormControl className={classes.selectType}>
                                                         <InputLabel id="cardType">CardType</InputLabel>
                                                         <Select
                                                         labelId="cardType"
                                                         id="cardType-select"
                                                         open={cardTypeOpen}
                                                         onClose={handleCardTypeClose}
                                                         onOpen={handleCardTypeOpen}
                                                         value={cardType}
                                                         onChange={handleCardTypeChange}
                                                         > 

                                                         <MenuItem value="">
                                                             <em>None</em>
                                                         </MenuItem>  
                                                         <MenuItem value="VISA_CARD">visaCardOffline</MenuItem>
                                                       
                                                         <MenuItem value="MASTER_CARD">masterCardOffline</MenuItem>
                                                         <MenuItem value="UNION_PAY_CARD">unionPayCardOffline</MenuItem>
                                                         <MenuItem value="DINERS_CLUB_CARD_OR_DISCOVER_CARD">dinersClubCardOrDiscoverCardOffline</MenuItem>
                                                         <MenuItem value="JCB_CARD">jcbCardOffline</MenuItem>
                                                         <MenuItem value="AMEX_CARD">amexCardOffline</MenuItem>
                                                         
                                                         </Select>
                                                     </FormControl>
                                           </Paper>
                       
                        </Item>
                    </Grid>

                    <Grid item xs={4}>
                        <Item elevation={0}>
                        <Paper className={classes.selectType}>
                                                
                        
                                                <FormControl className={classes.selectType}>
                                                         <InputLabel id="cardBelong">CardBelong</InputLabel>
                                                         <Select
                                                         labelId="cardBelong"
                                                         id="cardBelong-select"
                                                         open={cardBelongOpen}
                                                         onClose={handleCardBelongClose}
                                                         onOpen={handleCardBelongOpen}
                                                         value={cardBelong}
                                                         onChange={handleCardBelongChange}
                                                         > 

                                                         <MenuItem value="">
                                                             <em>None</em>
                                                         </MenuItem>  
                                                         <MenuItem value="local">local</MenuItem>
                                                       
                                                         <MenuItem value="foreign">foreign</MenuItem>
                                                         
                                                         
                                                         </Select>
                                                     </FormControl>
                                           </Paper>

                
                        </Item>
                    </Grid>
                 </Grid>
                        
                       
                 <Grid container spacing={2}>
                        <Grid item xs={4}>
                            <Item elevation={0}>
                            <Button type="submit" variant="outlined" className="btn right">Submit</Button>
                            </Item>
                        </Grid>
                        <Grid item xs={4}>
                            <Item elevation={0}>
                            <Button variant ="outlined" onClick={handleAddClose} className="btn right">close</Button>
                            </Item>
                        </Grid>
                        
                 </Grid>


                  

                       
                        


                </form>
            </Container>
   
    );
}

